import React, { FunctionComponent, ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { Flex, Box, Text } from 'mdlkit';

const StyledBreadcrumbWrapper = styled(Flex)<{
  active: boolean;
  completed: boolean;
}>`
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  text-align: center;

  &:before {
    content: '';
    position: absolute;
    border-top: 2px solid ${({ theme }) => theme.colors.borderGray};
    top: 12px;
    ${({ completed, active, theme }) =>
      (active || completed) &&
      css`
        border-top: 2px solid ${theme.colors.primary};
      `}
  }

  & + &:before {
    width: calc(100% - 32px);
    transform: translateX(calc(-50% - 16px));
  }
`;

const IconWrapper = styled(Box)`
  display: inline-block;
  position: relative;
  vertical-align: middle;
`;

const StyledText = styled(Text)<{ active: boolean }>`
  max-width: 80px;
  color: ${({ theme }) => theme.colors.gray};

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.colors.black};
      font-weight: ${({ theme }) => theme.fontWeights.bold};
    `}
`;

interface BreadcrumbProps {
  id: string;
  text: string;
  m?: string;
  active: boolean;
  completed: boolean;
  icon: ReactElement;
}

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({
  id,
  text,
  active,
  completed,
  icon,
  ...rest
}: BreadcrumbProps) => {
  const breadcrumbIcon = React.cloneElement(icon, { active, completed });

  return (
    <StyledBreadcrumbWrapper
      as="li"
      id={id}
      active={active}
      completed={completed}
      {...rest}
    >
      <IconWrapper>{breadcrumbIcon}</IconWrapper>

      <StyledText active={active}>{text}</StyledText>
    </StyledBreadcrumbWrapper>
  );
};

export default Breadcrumb;
